const initialState = {
    composer: {
        text: '',
        image: null
    }
}

export default function composer(state = initialState, action) {
    switch(action.type) {
        
        case 'SET_TEXT':
            return {
                ...state,
                composer: {
                    ...state.composer,
                    text: action.payload
                }
            }
        
        case 'SET_IMAGE':
            return {
                ...state,
                composer: {
                    ...state.composer,
                    image: action.payload
                }
            }

        case 'RESET_COMPOSER':
            return {
                ...state,
                composer: {
                    text: '',
                    image: null
                }
            }    
        
        default:
            return state    
    }
}